<div *ngIf="listOnly; else select">
    <span *ngFor="let platform of ad.platforms; trackBy: utils.trackByIndex">{{platform}}</span>
</div>
<ng-template #select>
    <div class="dropdown ad-platforms-dropdown" #dropdown>
        <button 
            class="trigger" 
            (click)="togglePanel()">
            <span *ngIf="ad.platforms.length > 0; else placeholder" class="selected" [title]="getAdPlatformList()" [innerHtml]="getAdPlatformList()"></span>
            <ng-template #placeholder>
                <span class="selected placeholder">Ad Platform</span>
            </ng-template>
            <mat-icon>keyboard_arrow_down</mat-icon> 
        </button>
        <div class="options-panel mat-elevation-z2" [ngClass]="{'open': panelOpen}">
            <ul class="options">
                <li *ngFor="let platform of platformList; let i = index; trackBy: utils.trackByIndex">
                    <mat-checkbox [disabled]="canEdit !== true" [(ngModel)]="platform.checked" (change)="changePlatforms(platform)">{{platform.name}}</mat-checkbox>
                </li>
            </ul>
        </div>
    </div>
</ng-template>